import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.carrier}externalcarriercompanies`;

export interface ExternalCarrierCompanySummary {
  enumValue: string;
  displayName?: string;
}

export const getExternalCarrierCompaniesRequest = (): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getExternalCarrierCompaniesQuery = async (): Promise<
  BackResponse<ExternalCarrierCompanySummary[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<ExternalCarrierCompanySummary[]>>(
      getExternalCarrierCompaniesRequest(),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
